const cart = require("../../attachedEvents/cart");

module.exports = {
    handle: (e, data) => {
        if (!data) {
            return;
        }

        const {products, details} = data;

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

        const cartDetails = JSON.parse(details);

        const { customerId, emailAddress } = cartDetails;

        delete cartDetails.customerId;
        delete cartDetails.emailAddress;

        const viewCartData = {
            ecommerce: {
                view_cart: cartDetails,
                cart_products : JSON.parse(products)
            }
        };

        customerId ? viewCartData.userId = customerId : null;
        emailAddress ? viewCartData.email = emailAddress : null;

        dataLayer.push(viewCartData);
    }
}